// This file was generated by a custom prisma generator, do not edit manually.
export const SchedulingType = {
  ROUND_ROBIN: "ROUND_ROBIN",
  COLLECTIVE: "COLLECTIVE",
  MANAGED: "MANAGED",
} as const;

export type SchedulingType = (typeof SchedulingType)[keyof typeof SchedulingType];

export const PeriodType = {
  UNLIMITED: "UNLIMITED",
  ROLLING: "ROLLING",
  RANGE: "RANGE",
} as const;

export type PeriodType = (typeof PeriodType)[keyof typeof PeriodType];

export const IdentityProvider = {
  CAL: "CAL",
  GOOGLE: "GOOGLE",
  SAML: "SAML",
} as const;

export type IdentityProvider = (typeof IdentityProvider)[keyof typeof IdentityProvider];

export const UserPermissionRole = {
  USER: "USER",
  ADMIN: "ADMIN",
} as const;

export type UserPermissionRole = (typeof UserPermissionRole)[keyof typeof UserPermissionRole];

export const MembershipRole = {
  MEMBER: "MEMBER",
  ADMIN: "ADMIN",
  OWNER: "OWNER",
} as const;

export type MembershipRole = (typeof MembershipRole)[keyof typeof MembershipRole];

export const BookingStatus = {
  CANCELLED: "CANCELLED",
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED",
  PENDING: "PENDING",
} as const;

export type BookingStatus = (typeof BookingStatus)[keyof typeof BookingStatus];

export const EventTypeCustomInputType = {
  TEXT: "TEXT",
  TEXTLONG: "TEXTLONG",
  NUMBER: "NUMBER",
  BOOL: "BOOL",
  RADIO: "RADIO",
  PHONE: "PHONE",
} as const;

export type EventTypeCustomInputType = (typeof EventTypeCustomInputType)[keyof typeof EventTypeCustomInputType];

export const ReminderType = {
  PENDING_BOOKING_CONFIRMATION: "PENDING_BOOKING_CONFIRMATION",
} as const;

export type ReminderType = (typeof ReminderType)[keyof typeof ReminderType];

export const PaymentOption = {
  ON_BOOKING: "ON_BOOKING",
  HOLD: "HOLD",
} as const;

export type PaymentOption = (typeof PaymentOption)[keyof typeof PaymentOption];

export const WebhookTriggerEvents = {
  BOOKING_CREATED: "BOOKING_CREATED",
  BOOKING_PAID: "BOOKING_PAID",
  BOOKING_RESCHEDULED: "BOOKING_RESCHEDULED",
  BOOKING_REQUESTED: "BOOKING_REQUESTED",
  BOOKING_CANCELLED: "BOOKING_CANCELLED",
  BOOKING_REJECTED: "BOOKING_REJECTED",
  FORM_SUBMITTED: "FORM_SUBMITTED",
  MEETING_ENDED: "MEETING_ENDED",
  RECORDING_READY: "RECORDING_READY",
} as const;

export type WebhookTriggerEvents = (typeof WebhookTriggerEvents)[keyof typeof WebhookTriggerEvents];

export const AppCategories = {
  calendar: "calendar",
  messaging: "messaging",
  other: "other",
  payment: "payment",
  video: "video",
  web3: "web3",
  automation: "automation",
  analytics: "analytics",
  conferencing: "conferencing",
  crm: "crm",
} as const;

export type AppCategories = (typeof AppCategories)[keyof typeof AppCategories];

export const WorkflowTriggerEvents = {
  BEFORE_EVENT: "BEFORE_EVENT",
  EVENT_CANCELLED: "EVENT_CANCELLED",
  NEW_EVENT: "NEW_EVENT",
  AFTER_EVENT: "AFTER_EVENT",
  RESCHEDULE_EVENT: "RESCHEDULE_EVENT",
} as const;

export type WorkflowTriggerEvents = (typeof WorkflowTriggerEvents)[keyof typeof WorkflowTriggerEvents];

export const WorkflowActions = {
  EMAIL_HOST: "EMAIL_HOST",
  EMAIL_ATTENDEE: "EMAIL_ATTENDEE",
  SMS_ATTENDEE: "SMS_ATTENDEE",
  SMS_NUMBER: "SMS_NUMBER",
  EMAIL_ADDRESS: "EMAIL_ADDRESS",
} as const;

export type WorkflowActions = (typeof WorkflowActions)[keyof typeof WorkflowActions];

export const TimeUnit = {
  DAY: "DAY",
  HOUR: "HOUR",
  MINUTE: "MINUTE",
} as const;

export type TimeUnit = (typeof TimeUnit)[keyof typeof TimeUnit];

export const WorkflowTemplates = {
  REMINDER: "REMINDER",
  CUSTOM: "CUSTOM",
} as const;

export type WorkflowTemplates = (typeof WorkflowTemplates)[keyof typeof WorkflowTemplates];

export const WorkflowMethods = {
  EMAIL: "EMAIL",
  SMS: "SMS",
} as const;

export type WorkflowMethods = (typeof WorkflowMethods)[keyof typeof WorkflowMethods];

export const BillingType = {
  FREE_TIER: "FREE_TIER",
  TEAM: "TEAM",
  PER_USER: "PER_USER",
} as const;

export type BillingType = (typeof BillingType)[keyof typeof BillingType];

export const BillingStatus = {
  INACTIVE: "INACTIVE",
  ACTIVE: "ACTIVE",
} as const;

export type BillingStatus = (typeof BillingStatus)[keyof typeof BillingStatus];

export const BillingPaymentStatus = {
  INIT: "INIT",
  PAID: "PAID",
  ERROR: "ERROR",
  UNKNOWN: "UNKNOWN",
} as const;

export type BillingPaymentStatus = (typeof BillingPaymentStatus)[keyof typeof BillingPaymentStatus];

export const FeatureType = {
  RELEASE: "RELEASE",
  EXPERIMENT: "EXPERIMENT",
  OPERATIONAL: "OPERATIONAL",
  KILL_SWITCH: "KILL_SWITCH",
  PERMISSION: "PERMISSION",
} as const;

export type FeatureType = (typeof FeatureType)[keyof typeof FeatureType];

export const DocumentStatus = {
  DRAFT: "DRAFT",
  PENDING: "PENDING",
  COMPLETED: "COMPLETED",
} as const;

export type DocumentStatus = (typeof DocumentStatus)[keyof typeof DocumentStatus];

export const DocumentType = {
  PDF: "PDF",
} as const;

export type DocumentType = (typeof DocumentType)[keyof typeof DocumentType];

export const ValueType = {
  String: "String",
  Boolean: "Boolean",
  Number: "Number",
} as const;

export type ValueType = (typeof ValueType)[keyof typeof ValueType];

export const AuditActionType = {
  CREATE: "CREATE",
  UPDATE: "UPDATE",
  DELETE: "DELETE",
  REVISE: "REVISE",
  CONFIGURE: "CONFIGURE",
  VIEW: "VIEW",
  SIGN: "SIGN",
  SIGN_INVITE: "SIGN_INVITE",
  DOWNLOAD: "DOWNLOAD",
  SHARE: "SHARE",
  UNSHARE: "UNSHARE",
} as const;

export type AuditActionType = (typeof AuditActionType)[keyof typeof AuditActionType];

export const InclusionStatus = {
  FIRST_PAGE: "FIRST_PAGE",
  LAST_PAGE: "LAST_PAGE",
  ALL_PAGES: "ALL_PAGES",
  NO_PAGES: "NO_PAGES",
} as const;

export type InclusionStatus = (typeof InclusionStatus)[keyof typeof InclusionStatus];

export const ReadStatus = {
  NOT_OPENED: "NOT_OPENED",
  OPENED: "OPENED",
} as const;

export type ReadStatus = (typeof ReadStatus)[keyof typeof ReadStatus];

export const DocumentActorType = {
  CREATOR: "CREATOR",
  COLLABORATOR: "COLLABORATOR",
  SIGNATORY: "SIGNATORY",
  RECIPIENT: "RECIPIENT",
  CONTACT: "CONTACT",
  SYSTEM: "SYSTEM",
  UNKNOWN: "UNKNOWN",
} as const;

export type DocumentActorType = (typeof DocumentActorType)[keyof typeof DocumentActorType];

export const DocumentEventType = {
  SENT: "SENT",
  RESENT: "RESENT",
  VIEWED: "VIEWED",
  VIEW_DONE: "VIEW_DONE",
  SIGNED: "SIGNED",
  COMPLETED: "COMPLETED",
  DOWNLOADED: "DOWNLOADED",
  REMINDER: "REMINDER",
  AUDIT_VIEWED: "AUDIT_VIEWED",
  PRINTED: "PRINTED",
} as const;

export type DocumentEventType = (typeof DocumentEventType)[keyof typeof DocumentEventType];

export const SendStatus = {
  NOT_SENT: "NOT_SENT",
  SENT: "SENT",
} as const;

export type SendStatus = (typeof SendStatus)[keyof typeof SendStatus];

export const SigningStatus = {
  NOT_SIGNED: "NOT_SIGNED",
  SIGNED: "SIGNED",
} as const;

export type SigningStatus = (typeof SigningStatus)[keyof typeof SigningStatus];

export const FieldType = {
  SIGNATURE: "SIGNATURE",
  FREE_SIGNATURE: "FREE_SIGNATURE",
  DATE: "DATE",
  TEXT: "TEXT",
} as const;

export type FieldType = (typeof FieldType)[keyof typeof FieldType];

export const ActivityType = {
  BOOKED_MEETING: "BOOKED_MEETING",
  VISITED_LINK: "VISITED_LINK",
  VIEWED_DOCUMENT: "VIEWED_DOCUMENT",
  SIGNED_DOCUMENT: "SIGNED_DOCUMENT",
  VISITED_PLACE: "VISITED_PLACE",
} as const;

export type ActivityType = (typeof ActivityType)[keyof typeof ActivityType];
